/* eslint-disable consistent-return,max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import 'moment/locale/es';
// @material-ui/icons
import Check from '@material-ui/icons/Check';
// @material-ui/core components
import FilterStyles from 'assets/jss/AdsFilter';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// global variables
import { currencyFilterStatus, adCurrencies } from 'config';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import Datepicker from 'components/common/DatePicker';
import SectionDivider from 'components/common/SectionDivider/SectionDivider';
import moment from 'moment';

/**
 * @class
 * @extends React.Component
 */
class CurrencyFilterFilter extends React.Component {
  constructor(props) {
    super(props);
    const { appliedFilter } = props;
    this.state = {
      selectedStatus:
        (appliedFilter && appliedFilter.status) ||
        Object.keys(currencyFilterStatus),
      selectedCurrencies:
        (appliedFilter && appliedFilter.currency) || Object.keys(adCurrencies),
      localFilter: appliedFilter || null,
    };
  }

  /**
   * @description
   * Change filters.
   *
   * @param {Object} changedFilter - Changed filters values.
   * @returns {*} - No returns value.
   */
  handleChangeFilter = changedFilter => {
    const { localFilter } = this.state;
    const { filter } = this.props;
    const filters = { ...localFilter, ...changedFilter };
    this.setState({ localFilter: filters });
    filter(filters);
  };

  /**
   * @description
   * Update new selection filter type.
   *
   * @param {string} filter - Filter type to update.
   * @param {*} callback - Callback waiting for setState.
   * @returns {*} - An update function.
   */
  updateSelectedCheckboxes = (filter, callback) => {
    const { selectedStatus, selectedCurrencies } = this.state;
    switch (filter) {
      case 'status':
        return this.handleChangeFilter(
          selectedStatus.length === 0 || selectedStatus.length === 2
            ? { status: undefined }
            : { status: selectedStatus },
          callback,
        );
      case 'currency':
        return this.handleChangeFilter(
          selectedCurrencies.length === 0 || selectedCurrencies.length === 3
            ? { currency: undefined }
            : { currency: selectedCurrencies },
          callback,
        );
      default:
    }
  };

  /**
   * @description
   * Handle select status checkboxes.
   *
   * @param {string} checkLabel - Status selected.
   * @param {*} callback - Callback waiting for setState.
   * @returns {undefined} No return.
   */
  handleStatusCheck = (checkLabel, callback = null) => {
    const { selectedStatus } = this.state;
    if (selectedStatus.indexOf(checkLabel) !== -1) {
      const newSelected = selectedStatus.filter(
        status => status !== checkLabel,
      );
      this.setState({ selectedStatus: newSelected }, () =>
        this.updateSelectedCheckboxes('status', callback),
      );
    } else {
      this.setState(
        {
          selectedStatus: [...selectedStatus, checkLabel],
        },
        () => this.updateSelectedCheckboxes('status', callback),
      );
    }
  };

  /**
   * @description
   * Handle select currency checkboxes.
   *
   * @param {string} checkLabel - Currency selected.
   * @param {*} callback - Callback waiting for setCurrency.
   * @returns {undefined} No return.
   */
  handleCurrencyCheck = (checkLabel, callback = null) => {
    const { selectedCurrencies } = this.state;
    if (selectedCurrencies.indexOf(checkLabel) !== -1) {
      const newSelected = selectedCurrencies.filter(
        currency => currency !== checkLabel,
      );
      this.setState({ selectedCurrencies: newSelected }, () =>
        this.updateSelectedCheckboxes('currency', callback),
      );
    } else {
      this.setState(
        {
          selectedCurrencies: [...selectedCurrencies, checkLabel],
        },
        () => this.updateSelectedCheckboxes('currency', callback),
      );
    }
  };

  /**
   * @description
   * Render full filter's box.
   * @returns {*} - CurrencyFilterFilter's box.
   */
  render() {
    const { classes, restartFilters, t } = this.props;
    const { selectedStatus, selectedCurrencies, localFilter } = this.state;
    return (
      <div className={classes.expandFilters} style={{ marginBottom: 20 }}>
        <GridContainer>
          <GridItem xs={12}>
            <div style={{ padding: '0px 10px 10px 10px' }}>
              <GridContainer style={{ marginTop: '15px' }}>
                <GridItem xs={12} md={2}>
                  <GridItem>
                    <SectionDivider
                      label={t('currency_filter.filters.section.status')}
                    >
                      <GridItem>
                        <FormControlLabel
                          control={
                            <Checkbox
                              className={classes.checked}
                              onClick={() =>
                                this.handleStatusCheck(
                                  currencyFilterStatus.ENABLED,
                                )
                              }
                              checked={
                                selectedStatus.indexOf(
                                  currencyFilterStatus.ENABLED,
                                ) !== -1
                              }
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                            />
                          }
                          id="statusEnabledCheckbox"
                          label={t('currency_filter.list.status.enabled')}
                          style={{ width: '100%' }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              className={classes.checked}
                              onClick={() =>
                                this.handleStatusCheck(
                                  currencyFilterStatus.DISABLED,
                                )
                              }
                              checked={
                                selectedStatus.indexOf(
                                  currencyFilterStatus.DISABLED,
                                ) !== -1
                              }
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                            />
                          }
                          id="statusDisabledCheckbox"
                          label={t('currency_filter.list.status.disabled')}
                          style={{ width: '100%' }}
                        />
                      </GridItem>
                    </SectionDivider>
                  </GridItem>
                </GridItem>
                <GridItem xs={12} md={2}>
                  <GridItem>
                    <SectionDivider
                      label={t('currency_filter.filters.section.currency')}
                    >
                      <GridItem>
                        {Object.keys(adCurrencies).map(currency => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                className={classes.checked}
                                onClick={() =>
                                  this.handleCurrencyCheck(currency)
                                }
                                checked={
                                  selectedCurrencies.indexOf(currency) !== -1
                                }
                                checkedIcon={
                                  <Check className={classes.checkedIcon} />
                                }
                                icon={
                                  <Check className={classes.uncheckedIcon} />
                                }
                              />
                            }
                            id={`currency${currency}CheckBox`}
                            key={`currency${currency}CheckBox`}
                            label={currency}
                            style={{ width: '100%' }}
                          />
                        ))}
                      </GridItem>
                    </SectionDivider>
                  </GridItem>
                </GridItem>
                <GridItem xs={12} md={6}>
                  <GridItem>
                    <SectionDivider
                      label={t('currency_filter.filters.section.date.section')}
                    >
                      <GridItem>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={6}>
                            <Datepicker
                              data-cy="currencyFilterDateFrom"
                              title={t(
                                'currency_filter.filters.section.date.from',
                              )}
                              defaultValue={t(
                                'currency_filter.filters.section.date.from_placeholder',
                              )}
                              onChange={date => {
                                if (localFilter.to && localFilter.to < date) {
                                  return;
                                }
                                this.handleChangeFilter({
                                  from: date
                                    ? moment(date)
                                        .startOf('day')
                                        .format()
                                    : undefined,
                                });
                              }}
                              value={
                                localFilter.from !== undefined &&
                                localFilter.from !== null
                                  ? moment(localFilter.from)
                                  : ''
                              }
                              validGte={localFilter.to}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Datepicker
                              data-cy="currencyFilterDateTo"
                              title={t(
                                'currency_filter.filters.section.date.to',
                              )}
                              defaultValue={t(
                                'currency_filter.filters.section.date.to_placeholder',
                              )}
                              onChange={date => {
                                if (
                                  localFilter.from &&
                                  localFilter.from > date
                                ) {
                                  return;
                                }
                                this.handleChangeFilter({
                                  to: date
                                    ? moment(date)
                                        .endOf('day')
                                        .format()
                                    : undefined,
                                });
                              }}
                              value={
                                localFilter.to !== undefined &&
                                localFilter.to !== null
                                  ? moment(localFilter.to)
                                  : ''
                              }
                              validLte={localFilter.from}
                            />
                          </GridItem>
                        </GridContainer>
                      </GridItem>
                    </SectionDivider>
                  </GridItem>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer justify="flex-end">
              <GridItem>
                <Button
                  color="danger"
                  simple
                  className={classes.buttons}
                  onClick={() => {
                    this.setState({
                      selectedStatus: Object.keys(currencyFilterStatus),
                      localFilter: {},
                    });
                    restartFilters();
                  }}
                  id="restartFilters"
                  key="restartFilters"
                >
                  {t('ad.filters.clean')}
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

/**
 * PaidAdFilter PropTypes
 * @param classes - styles received from withStyles
 * @param appliedFilter - prop to know applied filters
 * @param t - prop from HOC with string translations
 * @param i18n - prop from HOC with string translations
 * @callback filter - callback called when user clicks filter button
 * @callback restartFilters - callback called when user restart filters button
 */

CurrencyFilterFilter.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  appliedFilter: PropTypes.shape({}).isRequired,
  filter: PropTypes.func.isRequired,
  restartFilters: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(
  withStyles(FilterStyles)(CurrencyFilterFilter),
);
